import { CSSProperties } from 'react';
import { Record as RaRecord } from 'react-admin';
import { CircularProgress, TextField } from '@material-ui/core';
import { AutocompleteRenderInputParams } from '@material-ui/lab';

// Callers type the record as their own DTO, as react-admin's OptionText allows.
export type OptionText = string | ((item: any) => string);

export const LAZY_AUTOCOMPLETE_STYLE: CSSProperties = {
  marginTop: '8px',
  marginBottom: '4px',
  minWidth: '220px',
};

export const optionLabelOf =
  (optionText: OptionText) =>
  (option: RaRecord | null): string =>
    typeof optionText === 'function'
      ? option
        ? optionText(option)
        : ''
      : option?.[optionText] ?? '';

export const sameOptionBy =
  (optionValue: string) => (option: RaRecord, selected: RaRecord) =>
    option?.[optionValue] === selected?.[optionValue];

interface LazyReferenceTextFieldProps {
  params: AutocompleteRenderInputParams;
  label: string;
  loading: boolean;
}

export const LazyReferenceTextField = ({
  params,
  label,
  loading,
}: LazyReferenceTextFieldProps) => (
  <TextField
    {...params}
    label={label}
    variant="filled"
    margin="dense"
    InputProps={{
      ...params.InputProps,
      endAdornment: (
        <>
          {loading ? <CircularProgress color="inherit" size={20} /> : null}
          {params.InputProps.endAdornment}
        </>
      ),
    }}
  />
);
